var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwiterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9766 20.0007C40.9766 30.1019 33.4911 38.4529 23.7669 39.808C22.8577 39.9341 21.9274 40 20.9832 40C19.8932 40 18.8228 39.9131 17.7805 39.745C8.26084 38.2118 0.989746 29.9548 0.989746 20.0007C0.989746 8.95491 9.94202 0 20.9846 0C32.0271 0 40.9794 8.95491 40.9794 20.0007H40.9766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0987 8.82178L18.32 21.154L9.04126 31.181H11.1301L19.2544 22.4027L25.818 31.181H32.9252L23.1856 18.1551L31.8226 8.82178H29.7338L22.2525 16.9064L16.2073 8.82178H9.10009H9.0987ZM12.1696 10.3605H15.4339L29.8514 29.6423H26.5872L12.1696 10.3605Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiterIcon);
export default __webpack_public_path__ + "static/media/twiter_icon.06e79b5f37917a875439f01cb4225b74.svg";
export { ForwardRef as ReactComponent };